import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DashboardDetailWrapper } from './DashboardDetailStyle';
import DashboardDetailHeader from './DashboardDetailHeader';
import DashboardDetailInfo from './DashboardDetailInfo';
import DashboardDetailFlowerInfo from './DashboardDetailFlowerInfo';
import DashboardMarketPrice from './DashboardMarketPrice';
import DashboardDetailFooter from './DashboardDetailFooter';
import { Container, SearchHeader, SearchInput } from '../search/DashboardSearchInputStyle';
import Magnifier from 'assets/icons/Magnifier.svg';
import BackLinkIcon from 'assets/icons/left_arrow.svg';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const DashboardDetail = () => {
   const useQuery = key => {
      const searchParams = useLocation().search;
      const value = new URLSearchParams(searchParams).get(key);
      if (value === undefined || value === null) return -1;
      return Number(value);
   };
   let navigate = useNavigate();
   const { f_name } = useParams();
   const listType = Number(useQuery('listType'));
   const infoIcon = document.querySelector('.moreinfo-icon');
   const infoIconTop = infoIcon?.getBoundingClientRect().top;
   const infoIconLeft = infoIcon?.getBoundingClientRect().left;

   return (
      <DashboardDetailWrapper>
         {listType === 0 ? (
            <>
               <Container>
                  <SearchHeader>
                     <img
                        src={BackLinkIcon}
                        alt="Back Link button"
                        onClick={() => navigate('/dashboard/search')}
                     />
                  </SearchHeader>
                  <SearchInput>
                     <img src={Magnifier} alt="Magnifier" />
                     <input
                        onClick={() => navigate('/dashboard/search')}
                        type="search"
                        placeholder="꽃 품목 혹은 꽃 이름을 검색해 보세요."
                        value={f_name}
                     />
                  </SearchInput>
               </Container>
            </>
         ) : (
            <DashboardDetailHeader />
         )}
         <DashboardDetailInfo top={infoIconTop} left={infoIconLeft} />
         <DashboardDetailFlowerInfo />
         <DashboardMarketPrice />
         <DashboardDetailFooter />
      </DashboardDetailWrapper>
   );
};

export default DashboardDetail;
